// extracted by mini-css-extract-plugin
export default {"table":"Table_table__WDkWk","image":"Table_image__E+1Np","icon":"Table_icon__+GVwK","titleTd":"Table_titleTd__fV+Qu"};